import { useSyncExternalStore } from 'react';
import { getColourScheme, setColourScheme, subscribeColourScheme } from './areaData.js';

// The active score colour scheme ('discrete' | 'heat', areaData.js) for React: re-renders on change.
export const useColourScheme = () => {
    const scheme = useSyncExternalStore(subscribeColourScheme, getColourScheme, getColourScheme);
    return [scheme, setColourScheme];
};

export default useColourScheme;
